import axios from "axios";
import React, { useState } from "react";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary(props) {
  let [keyword, setKeyword] = useState(props.defaultKeyword);
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);

  function handlePexelsResponse(response) {
    setPhotos(response.data.photos);
  }

  function handleDictionaryResponse(response) {
    setResults(response.data[0]);
  }

  function search() {
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleDictionaryResponse);

    let pexelsApiKey =
      "563492ad6f91700001000001dc3c41e5ed854f00a9c82e6874bdbfff";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=6`;
    let headers = { Authorization: `Bearer ${pexelsApiKey}` };
    axios.get(pexelsApiUrl, { headers: headers }).then(handlePexelsResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function updateKeyword(event) {
    setKeyword(event.target.value);
  }

  function load() {
    setLoaded(true);
    search();
  }

  if (loaded) {
    return (
      <div className="Dictionary">
        <section>
          <h1>
            What word would you like to look up?{" "}
            <span role="img" aria-label="magnifying glass">
              🔎
            </span>
          </h1>
          <form className="search-form text-center" onSubmit={handleSubmit}>
            <input
              type="search"
              autoFocus="on"
              placeholder="Enter a word here"
              onChange={updateKeyword}
              className="search"
            ></input>
            <input
              type="submit"
              value="Search"
              className="search-button"
            ></input>
          </form>
        </section>
        <Results results={results} />
        <Photos photos={photos} />
        <footer>
          <a
            href="https://github.com/katiewalker126/dictionary-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open-source code
          </a>{" "}
          by Katie Walker
        </footer>
      </div>
    );
  } else {
    load();
  }
}
